export default {
  "content": "<path d=\"M15 8.05H6.41L8.7 5.76 7.29 4.34l-4 4a.996.996 0 000 1.41l4 4 1.41-1.41-2.29-2.29H15c2.21 0 4 1.79 4 4s-1.79 4-4 4H6v2h9c3.31 0 6-2.69 6-6s-2.69-6-6-6z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};